import config from '../config.js';
export const stripLeadingSlash = (input) => input.replace(/^\//, '');
export const stripTrailingSlash = (input) => input.replace(/\/$/, '');
export const asset = (path) => `${config.assetsBaseUrl}/${stripLeadingSlash(path)}`;
export const api = (path) => `${config.apiBaseUrl}/${stripLeadingSlash(path)}`;
export const marketingSite = (path) => `${config.marketingSiteBaseUrl}/${stripLeadingSlash(path)}`;
export const webApp = (path) => `${config.webAppBaseUrl}/${stripLeadingSlash(path)}`;
//# sourceMappingURL=index.js.map